import cc from 'classcat';
import React, { FC } from 'react';
import * as styles from './Placeholder.module.scss';
import PlaceholderParagraph from './PlaceholderParagraph';
import PlaceholderTextField from './PlaceholderTextField';

interface PlaceholderComponent extends FC<PlaceholderProps> {
  Paragraph: typeof PlaceholderParagraph;
  TextField: typeof PlaceholderTextField;
}

interface PlaceholderProps {
  children?: string;
  className?: string;
  size?: number;
}

const Placeholder: PlaceholderComponent = ({ children, className, size }) => {
  return (
    <span className={cc([styles.placeholder, className])} style={{ width: size }}>
      {children ?? '\u00A0'}
    </span>
  );
};

Placeholder.Paragraph = PlaceholderParagraph;
Placeholder.TextField = PlaceholderTextField;

export default Placeholder;
